
import { observer, inject } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Text } from "../UI";
import { useTheme } from "styled-components";
import { useMobile } from "../utils/mobile";
import { format } from "date-fns";
import arrowLeft from "../assets/img/arrow-left.svg"
import messageImg from "../assets/img/message_icon.svg";
import notificationImg from "../assets/img/notification.svg";


const RepairMessageList = ({ repairPagesStore,
    userStore,
    tenantsStore, newMessages, project,
    setShowMessageMenu = () => { }
}) => {
    const { t, i18n } = useTranslation("applies");
    const theme = useTheme();
    const isRtl = i18n.dir() === "rtl";

    const navigate = useNavigate();
    const isMobile = useMobile();

    const handleRepairPageSelected = async (message) => {
        let note = null;

        if (message?.REPAIRNAME) {
            const body = {
                MAINCUST: tenantsStore.selectedSiteSpace.CUST,
                MAINENV: tenantsStore.selectedSiteSpace?.DNAME,
                CUST: tenantsStore.selectedSiteSpace.CUST,
                DNAME: tenantsStore.selectedContract?.DNAME,
                ENV: tenantsStore.selectedContract?.DNAME,
                CONTNAME: tenantsStore.selectedContract?.CONTNAME,
                SPACENAME:
                    tenantsStore.selectedContract?.SPACENAME ||
                    tenantsStore.selectedSiteSpace?.SPACENAME,

                CONT: tenantsStore.selectedContract?.CONT,
                REPAIRNAME: message.REPAIRNAME,
            };

            note = await repairPagesStore.getRepairPage(body);

            if (!!note?.EXAMINERUSERID) {
                const examinBody = {
                    USERID: note.EXAMINERUSERID,
                    CUST: userStore.userDetails.CUST,
                    MAINENV: userStore.userDetails.MAINENV,
                    ENV: tenantsStore.selectedContract?.DNAME,
                    DNAME: tenantsStore.selectedContract?.DNAME,
                };
                const examiner = await repairPagesStore.getExaminUserData(examinBody);
                note["EXAMINERCALENDLYLINK"] =
                    examiner?.USERSCURENV_SUBFORM.ZCOB_CALENDLYLINK;
                note["ZCOB_CALENDLYEVISIT"] =
                    examiner?.USERSCURENV_SUBFORM.ZCOB_CALENDLYEVISIT;
                note["ZCOB_CALENDLYEFIX"] =
                    examiner?.USERSCURENV_SUBFORM.ZCOB_CALENDLYEFIX;
            }
            repairPagesStore.setSelectedRepairPage(note);
            setShowMessageMenu(false);

            if (
                tenantsStore.selectedSiteSpace?.CONTSALE !== "Y" ||
                tenantsStore.selectedSiteSpace?.ISONLYBEDEK === "Y" ||
                project?.BEDEK === "Y"
            ) {
                !!isMobile ? navigate("/bedek/repair_messages") : navigate("/bedek/applies");
            } else {
                !!isMobile ? navigate("/tenant/repair_messages") : navigate("/tenant/applies");
            }

        };
    }

    const handleMessageSelected = async (message) => {
        await tenantsStore.setSelectedMessage(message);
        setShowMessageMenu(false);
        navigate("/tenant/messages");
        ;
    }


    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flex: 1,
                padding: 20
            }}
        >



            <div style={{ marginBottom: 4 }}>
                <Text.BM color={theme.color.gray90}>
                    {t("applies:new_repair_messages",
                        {
                            num: newMessages.length,
                        }
                    )}
                </Text.BM>
            </div>
            {newMessages.map((msg, index) => (
                <div key={index}
                    onClick={() => {
                        !!msg?.REPAIRMSG ? handleRepairPageSelected(msg)
                            : handleMessageSelected(msg)
                    }}
                    style={{
                        display: "flex", flexDirection: "row",
                        alignItems: "center", gap: 10, marginBottom: 10,
                        padding: 5

                    }}>
                    <div style={{
                        backgroundColor: theme.color.gray30,
                        borderRadius: 50,
                        width: 44,
                        height: 44,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <img
                            src={!!msg?.REPAIRMSG ? messageImg : notificationImg}
                            alt="message"
                        />
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", borderBottom: `1px solid ${theme.color.gray30}`, paddingBottom: 10, }}>


                        <div style={{ display: "flex", flexDirection: "column", gap: 2, justifyContent: "flex-start", alignItems: "flex-start" }}>
                            <Text.BM color={theme.color.gray90}>{!!msg?.REPAIRMSG ? t("applies:new_contract_message") : msg?.HEADER}</Text.BM>
                            <Text.SM color={theme.color.gray70}>  {!!msg?.REPAIRMSG ? `${t("bedek")} / ${t("applies:inquiry_number", {
                                num: msg.REPAIRNAME,
                            })}` : t("applies:messages")}  </Text.SM>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 2, justifyContent: "flex-end", alignItems: "flex-end" }}>
                            <Text.SMR color={theme.color.gray70}>{format(
                                !!msg?.REPAIRMSG ? msg?.COMDATE !== undefined
                                    ? new Date(msg?.COMDATE)
                                    : new Date() : msg?.MESSAGEDATE !== undefined
                                    ? new Date(msg?.MESSAGEDATE)
                                    : new Date(),
                                "dd/MM/yyyy"
                            )}</Text.SMR>
                            <div style={{ display: "flex", flexDirection: "row", gap: 4, justifyContent: "flex-end", alignItems: "flex-end" }}>
                                <Text.SM color={theme.color.primary}
                                    style={{
                                        textAlign: "end"

                                    }}>{t("applies:to_watch")}</Text.SM>
                                <img
                                    style={{
                                        transform: isRtl ? "rotate(0)" : "rotate(180deg)"
                                    }}
                                    src={arrowLeft}
                                    alt="left"

                                />
                            </div>

                        </div>

                    </div>
                </div>
            ))}
        </div>
    );
};

export default inject("tenantsStore", "repairPagesStore", "userStore")(observer(RepairMessageList));










